export const DARK_VIEWS = ['primaryLight', 'secondaryDark', 'textDark'];
